// PricingHero — Title, subtitle, and billing toggle matching the Figma design

"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { YEARLY_DISCOUNT_PERCENT } from "./pricing-data";
interface PricingHeroProps {
  isYearly: boolean;
  onToggle: (yearly: boolean) => void;
}
export function PricingHero(t0) {
  const $ = _c(20);
  const {
    isYearly,
    onToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-ds-focus-brand text-center text-sm font-medium uppercase tracking-wide">Pricing</motion.p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:leading-display text-ds-text-primary -mt-4 text-center text-4xl font-medium tracking-[-2.56px] md:text-6xl">Choose your plan</motion.h1>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.15
    }} className="text-ds-text-slate leading-label -mt-4 text-center text-lg opacity-70">Scale your automation with the right plan for your team.</motion.p>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 20
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.5,
      delay: 0.3
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t4 = $[3];
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onToggle) {
    t7 = () => onToggle(false);
    $[6] = onToggle;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = `relative z-10 flex h-11 items-center justify-center rounded-xl px-3 text-base font-medium transition-all ${!isYearly ? "bg-white text-zinc-700 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]" : "text-zinc-500"}`;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = <button type="button" onClick={t7} className={t8}>Monthly Plans</button>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onToggle) {
    t10 = () => onToggle(true);
    $[11] = onToggle;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = `relative z-10 flex h-11 items-center justify-center gap-1.5 rounded-xl px-2.5 text-base font-medium transition-all ${isYearly ? "bg-white text-zinc-700 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]" : "text-zinc-500"}`;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="flex items-center gap-1 rounded-md border border-zinc-300 bg-white px-1.5 py-1 text-sm font-medium text-zinc-700 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]"><span className="size-2 rounded-full bg-emerald-500" />{`${YEARLY_DISCOUNT_PERCENT}% OFF`}</span>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t11) {
    t13 = <button type="button" onClick={t10} className={t11}>Yearly Plans{t12}</button>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13 || $[18] !== t9) {
    t14 = <section className="mx-auto flex max-w-[1280px] flex-col items-center gap-8 pb-8 pt-16 sm:pt-20">{t1}{t2}{t3}<motion.div initial={t4} animate={t5} transition={t6} className="relative flex items-center gap-1 rounded-2xl border border-zinc-200 bg-zinc-50 p-1.5">{t9}{t13}</motion.div></section>;
    $[17] = t13;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}